module.exports = __webpack_public_path__ + "img/zoll-r-series.30f673c4.png";